import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import qs from 'query-string';
import TrackingPixel from '../../common/components/TrackingPixel/TrackingPixel';

const PrivateRoute = ({
  component: Component, location, routes, ...otherProps
}) => {
  const accessToken = useSelector(state => state.auth.accessToken);

  useEffect(() => {
    if (!accessToken) {
      window.sessionStorage.setItem('redirect_url', qs.stringify(location));
    }
  }, [accessToken, location]);

  return (
    <Route
      {...otherProps}
      render={props => (accessToken
        ? (
          <>
            <TrackingPixel />
            <Component {...props} routes={routes} />
          </>
        )
        : (
          <Redirect
            to={{
              pathname: '/users/callback',
              state: { from: location },
              hash: location.hash,
            }}
          />
        ))}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
  }),
  routes: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string,
  })),
};

PrivateRoute.defaultProps = {
  location: {},
  routes: undefined,
};

export default PrivateRoute;
